export default function AI_Prompt_Home() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">AI Prompt Home</h1>
    </div>
  );
}
